export interface BundleMessageLocation {
  file: string;

  /** 1-based */
  line: number;

  /** 0-based, in bytes */
  column: number;

  /** in bytes */
  length?: number;

  lineText?: string;

  suggestion?: string;
}
